import { Asterisk } from 'lucide-react';

export function RequiredAsterisk() {
  return <Asterisk className="size-3 text-destructive" />;
}
